import React from 'react'
import { useState, useCallback,  } from 'react'
const Calculator = ({attributes}) => {
	// const {results, calcMethod, leverage, entryPrice, exitPrice, quantity} = attributes
	// const [results, setResults] = useState(null);
	const [calcMethod, setCalcMethod] = useState("Long");
	const [leverageIndex, setLeverageIndex] = useState(0);
	// const [leverageStep, setLeverageStep] = useState(4);
	const [leverageSteps, setLeverageSteps] = useState([1,5,10,15,20,25,30,35,40,45,50,55,60,65,70,75,80,85,90,95,100,105,110,115,120,125]);
	const [entryPrice, setEntryPrice] = useState(null);
	const [exitPrice, setExitPrice] = useState(null);
	const [quantity, seQuantity] = useState(null);
	const [initialMargin, setInitialMargin] = useState(null);
	const [pnl, setPnl] = useState(null);
	const [roe, setRoe] = useState(null);


	// const handleCalculation = useCallback(
	// 	(data) => setResults(prevState => data
	// 	),
	// []);

	// const handleLeverageInput = (e) => {
	// 	console.log('leverageValue')
	// 	const leverageValue = e.target.value
	// 	console.log(leverageValue)
	// 	console.log(leverageStep,'leverageStep')
	// 	if (leverage > 1 && leverageValue === 1) {
	// 		console.log('Step to 4')
	// 		setLeverage(leverageValue)
	// 		setLeverageStep(4)
	// 	} else {
	// 		console.log('Step to 5')
	// 		setLeverage(leverageValue)
	// 		setLeverageStep(5)
	// 	}
	//   };

	

	// const handleLeverage = useCallback((leverageValue) => {
	// 	console.log(leverageValue, 'leverageValue')
	// 	setLeverage((prevState) => leverageValue)
	//   }, [leverage]);

	const handleLeverage = (e) => {
		const {name,value} = e.target;
		setLeverageIndex((prev) => (value ));
	}

	
	// useEffect(() => {
	// 	// Update the document title using the browser API
	// 	if (leverage === 1) {
	// 		setLeverageStep((prevState) => 4)
	// 	} else {
	// 		setLeverageStep((prevState) => 5)
	// 	}
	//   }, [leverage]);
	  
	// const handleLeverageStep = (e) => {
	// 	const {name,value} = e.target;
	// 	setLeverage((prev) => ({ ...prev, [name]: value }));
	// 	console.log(leverageStepValue, 'leverageStepValue')
	// 	// setLeverageStep((prevState) => leverageStepValue)
	//   }

	const handleEntryPrice = useCallback((entryPriceValue) => {
		setEntryPrice((prevState) => entryPriceValue)
	  }, []);

	const handleExitPrice = useCallback((exitPriceValue) => {
		setExitPrice((prevState) => exitPriceValue)
	  }, []);

	const handleQuantity = useCallback((quantityValue) => {
		seQuantity((prevState) => quantityValue)
	  }, []);

	// document.querySelector('form').addEventListener('submit', e => {
	// e.preventDefault();
	// const data = new FormData(e.target);
	// console.log([...data.entries()]);
	// calculateFutures([...data.entries()])
	// });

	const calculateInitialMargin = (quantity,entryPrice,imr) => {
	return (quantity * entryPrice * imr)
	}

	const calculatePNL = (calcMethod, entryPrice, exitPrice, quantity) => {
	if(calcMethod === "Long") {
		return ((exitPrice - entryPrice) * quantity)
		} else {
		return ((entryPrice - exitPrice) * quantity)
	}
	}

	const calculateROE = (calcMethod,entryPrice,exitPrice,quantity, leverage) => {
	return (calculatePNL(calcMethod,entryPrice,exitPrice,quantity) / calculateInitialMargin(quantity,entryPrice, (1/leverage)))
	}

	const calculateFutures = () => {
	console.log(calcMethod)
	console.log(entryPrice)
	console.log(exitPrice)
	console.log(quantity)
	const leverage = leverageSteps[leverageIndex]
	console.log(leverage)
	let initialMarginValue = calculateInitialMargin(quantity,entryPrice,(1/leverage))
	let pnlValue = calculatePNL(calcMethod,entryPrice,exitPrice,quantity)
	let roeValue = calculateROE(calcMethod,entryPrice,exitPrice,quantity,leverage)
	setInitialMargin(`${initialMarginValue.toFixed(2)} USDT`)
	setPnl(`${pnlValue.toFixed(2)} USDT`)
	setRoe(`${(roeValue * 100).toFixed(2)} %`)
	console.log(initialMarginValue)
	console.log(pnlValue)
	console.log(roeValue)
	// calcMethod,leverage,entryPrice,exitPrice,quantity
	}

	const handleCalcMethod = (method) => {
		console.log(calcMethod)
		setCalcMethod(method)
		console.log(calcMethod)
	}

	return (
		<div className="plugin-container">

		<h1>Futures Calculator</h1>
		<div className="calc-container">
			<div className="calc-method">
				<div onClick={(e) => handleCalcMethod('Long')} className={calcMethod === "Long" ? "longButton" : "longButton disabledButton"}>Long</div>
				<div onClick={(e) => handleCalcMethod('Short')} className={calcMethod === "Short" ? "shortButton" : "shortButton disabledButton"}>Short</div>
			</div>
			<span>Leverage:</span><span id="leverage-output">{leverageSteps[leverageIndex]}x</span><input onInput={(e) => {
				console.log('event on input',e) 
				handleLeverage(e)
				}} type="range" value={leverageIndex} name="leverageValue" className="form-range" min="0" max={leverageSteps.length - 1} step="1" id="customRange3"></input>
			<div className="input-container">
								<span>Entry Price:</span><div className="input-wrapper"><input onChange={(e) => {handleEntryPrice(e.target.value)}} name="entry_price" type="text"  /><span>USDT</span></div>
							</div>
							<div className="input-container">
								<span>Exit Price:</span><div className="input-wrapper"><input onChange={(e) => {handleExitPrice(e.target.value)}} name="exit_price"type="text" /><span>USDT</span></div>
							</div>
							<div className="input-container">
								<span>Quantity (Of Coins):</span><div className="input-wrapper"><input onChange={(e) => {handleQuantity(e.target.value)}} name="quantity" type="text"  /></div>
							</div>
							<button onClick={e => calculateFutures()} className={(!entryPrice || !exitPrice || !quantity) ? "disabledSubmit" : ""} id="submitButton">Calculate</button>
						</div>
					<div className="calc-results">
						<p>Initial Margin:<span className="result-span">{initialMargin}</span></p>
						<p>PNL:<span className="result-span">{pnl}</span></p>
						<p>ROE:<span className="result-span">{roe}</span></p>
					</div>
				</div>
	)
}

export default Calculator


//border on all the component with border radius
//inputs with gray border 1px solid #a9a9a9
//background white, text black